import React from 'react';
import { Menubar } from 'primereact/menubar';
import { useNavigate, useLocation } from 'react-router-dom';

const MenuUniformesTienda = ({link}) => {

    const location = useLocation();
    const navigate = useNavigate();

    const nestedMenuitems = [
        {
            label: 'Filtro',
            icon: 'pi pi-search',
            style: {
                textShadow: location.pathname === '/filtro/na' && '0 0 red',
                color: location.pathname === '/filtro/na' && '#9b2f3e !important',
                fontWeight: location.pathname === '/filtro/na' && '500',
                //textDecoration: location.pathname === '/filtro/na' && 'underline',
                textDecorationColor: location.pathname === '/filtro/na' && '#9b2f3e'

            },
            command: e => {
                navigate('/filtro/na');
            }
        }, {
            label: 'Pendientes',
            icon: 'pi pi-inbox',
            style: {
                textShadow: (location.pathname === '/pendientes' || location.pathname === '/multientrega-scanner/${IdAlumno}/${IdEncEntrega}/${Folio}' || location.pathname.substring(0,9) === '/resumen/') && '0 0 red',
                color: (location.pathname === '/pendientes' || location.pathname === '/multientrega-scanner/${IdAlumno}/${IdEncEntrega}/${Folio}' || location.pathname.substring(0,9) === '/resumen/') && '#9b2f3e !important',
                fontWeight: (location.pathname === '/pendientes' || location.pathname === '/multientrega-scanner/${IdAlumno}/${IdEncEntrega}/${Folio}' || location.pathname.substring(0,9) === '/resumen/') && '500',
                //textDecoration: (location.pathname === '/pendientes' || location.pathname === '/multientrega-scanner/${IdAlumno}/${IdEncEntrega}/${Folio}' || location.pathname.substring(0,9) === '/resumen/') && 'underline',
                textDecorationColor: (location.pathname === '/pendientes' || location.pathname === '/multientrega-scanner/${IdAlumno}/${IdEncEntrega}/${Folio}' || location.pathname.substring(0,9) === '/resumen/') && '#9b2f3e'
            },
            command: e => {
                navigate('/pendientes');
            }
        },/* {
            label: 'Evidencias',
            icon: 'pi pi-file',
            style: {
                textShadow: location.pathname === '/archivos' && '0 0 red',
                color: location.pathname === '/archivos' && '#9b2f3e !important',
                fontWeight: location.pathname === '/archivos' && '500',
                //textDecoration: location.pathname === '/archivos' && 'underline',
                textDecorationColor: location.pathname === '/archivos' && '#9b2f3e'
            },
            command: e => {
                navigate('/archivos');
            }
        }, */ 
        /* {
            label: 'Reportes',
            icon: 'pi pi-fw pi-cog',
            style: {
                textShadow: location.pathname === '/reporte/corte-tienda' && '0 0 red',
                color: location.pathname === '/reporte/corte-tienda' && '#9b2f3e !important',
                fontWeight: location.pathname === '/reporte/corte-tienda' && '500',
                //textDecoration: location.pathname === '/reporte/corte-tienda' && 'underline',
                textDecorationColor: location.pathname === '/reporte/corte-tienda' && '#9b2f3e'
            },
            items: [{ 
                label: 'Corte',
                icon: 'pi pi-fw pi-user-edit',
                command: e => {
                    navigate('/reporte/corte-tienda');
                }
            }]
        } */
    ];

    return (
        <div className="col-12" style={{marginBottom: "15px"}}>
            <Menubar model={nestedMenuitems} className="surface-card"></Menubar>
        </div>
    );
}

export default MenuUniformesTienda;